import React from 'react'
import * as R from 'remeda'

import { findByPath, type NineNumber, pathOr } from '~/utils'

import { useTabulationData } from '../../hooks/useTabulationQuery'

import styles from './Circle.css'
import CircleSvg from './circle.svg'

const minCircleWidthPercentage = 10
const maxCircleWidthPercentage = 100

export type CircleProps = {
  nineNumber: NineNumber
}

export const Circle = ({ nineNumber }: CircleProps) => {
  const tabulationData = useTabulationData()

  const [minRatio, maxRatio] = React.useMemo(() => {
    if (tabulationData.length === 0) {
      return [0, 1]
    }

    const ratios = tabulationData.map(R.prop('ratio'))

    return [Math.min(...ratios), Math.max(...ratios)]
  }, [tabulationData])

  const style = React.useMemo<React.CSSProperties>(() => {
    const ratio = R.pipe(
      tabulationData,
      findByPath('nineNumber', nineNumber),
      pathOr('ratio', NaN),
    )

    // maxRatio === minRatio（全セグメント同率、絞り込み結果0件など）だとゼロ除算でNaNになるため0扱いにする
    const value =
      maxRatio === minRatio ? 0 : (ratio - minRatio) / (maxRatio - minRatio)
    const root = value ** 0.5

    const width = `${
      minCircleWidthPercentage +
      (maxCircleWidthPercentage - minCircleWidthPercentage) * root
    }%`

    return { width }
  }, [maxRatio, minRatio, nineNumber, tabulationData])

  return <CircleSvg className={styles.root} style={style} />
}
